// Textos de las pantallas de la app (App.js) que no estaban en el diccionario
// base. Mismas claves en los tres idiomas; el español es el texto de referencia.
// Las llaves {x} se rellenan con tf('clave', { x }); los ** marcan negrita
// (componente Negrita).
export const app = {
  es: {
    // Secciones / navegación
    analysis: 'Análisis',
    users: 'Gestión',
    trading: 'Trading',
    rolAdmin: 'ADMIN',
    rolUsuario: 'USUARIO',
    rolAdministrador: 'ADMINISTRADOR',
    accesoRestringido: 'Acceso Restringido',
    elUsuario: 'El usuario',
    sinPermisoPara: 'no tiene permisos para acceder a',
    volverInicio: 'Volver al Inicio',
    noGuardado: 'No se ha guardado.',
    cerrar: 'Cerrar',
    // Suscripción
    precioMes: '2,50 $ / mes (precio de acceso anticipado)',
    subTrialEnded: 'Tu prueba gratuita ha terminado',
    subDaysLeftOne: 'Te queda 1 día de prueba',
    subDaysLeft: 'Te quedan {n} días de prueba',
    subExpiredBody: 'Puedes seguir consultando y exportando tus datos, pero no añadir ni modificar nada. Activa tu cuenta por {precio}.',
    subTrialBody: 'Cuando acabe podrás seguir consultando tus datos, pero no editarlos. {precio}.',
    // Errores de guardado
    errBloqueado: 'Tu cuenta está bloqueada: no se pueden guardar cambios. Contacta con el administrador.',
    errPruebaTerminada: 'Tu prueba gratuita ha terminado: los cambios no se guardan. Activa tu cuenta para seguir editando.',
    errPermisos: 'Firestore ha rechazado el cambio por falta de permisos. Se ha restaurado la última versión guardada.',
    errSinConexion: 'Sin conexión: el cambio no se ha podido guardar. Se ha restaurado la última versión guardada.',
    errGuardar: 'No se pudo guardar el cambio ({msg}). Se ha restaurado la última versión guardada.',
    errDesconocido: 'error desconocido',
    errSync: 'Error de sincronización: {msg}',
    // Subcategorías
    nombreSinSeparador: 'El nombre no puede contener el carácter "{sep}".',
    yaExisteAnio: 'Ya existe en este año',
    yaExisteEn: '"{nombre}" ya existe en {seccion} (en este año, en uno posterior o en la configuración).',
    addSubPlaceholder: 'Añadir subcategoría...',
    // Bloques del dashboard
    wKpis: 'Resumen del año (ingresos, gastos, ahorro)',
    wSalud: 'Salud financiera',
    wFlujo: 'Ingresos vs. gastos mensuales',
    wDistribucion: 'Distribución de gastos',
    wAhorroAcumulado: 'Ahorro acumulado: plan vs. real',
    wObjetivo: 'Objetivo de ahorro anual',
    wPresupuestoIngresos: 'Ingresos: presupuesto vs. real',
    wPresupuestoGastos: 'Gastos: presupuesto vs. real',
    wTopGastos: 'Dónde se va el dinero (top gastos)',
    wCategoria: 'Evolución de una categoría',
    wAhorroMensual: 'Ahorro por mes',
    wComparativa: 'Este año vs. el anterior',
    wPatrimonio: 'Patrimonio neto',
    wPrestamos: 'Progreso de préstamos',
    wTrading: 'Resumen de trading',
    // Dashboard (gráficos)
    sinIngresosRegistrados: 'Sin ingresos registrados',
    saludHasta: '(hasta {mes})',
    tasaAhorro: 'Tasa de ahorro',
    tasaAhorroNota: 'La parte de tus ingresos que ahorras. Referencia: 20 % o más.',
    fondoEmergencia: 'Fondo de emergencia',
    meses: 'meses',
    fondoNota: '{cats} entre el gasto medio mensual. Referencia: de 3 a 6 meses.',
    cargaDeuda: 'Carga de deuda',
    cargaDeudaNota: 'Cuotas de préstamos sobre el ingreso mensual medio. Referencia: por debajo del 30 %.',
    sinDatos: 'Sin datos',
    planSegunPresupuesto: 'Plan (según presupuesto)',
    objetivoPara: 'Objetivo para {year} ({moneda})',
    llevasDe: 'Llevas **{a}** de {b}.',
    ritmoActual: 'Al ritmo actual ({ritmo} al mes) terminarás el año con **{proy}**:',
    vasPorDelante: 'vas por delante del objetivo.',
    teFaltarian: 'te faltarían {x}.',
    objetivoCumplido: 'Objetivo cumplido.',
    faltaron: 'Faltaron {x}.',
    objetivoAyuda: 'Escribe cuánto quieres ahorrar este año y verás el progreso y una proyección a fin de año según tu ritmo actual.',
    presupuestoVsRealN: '{seccion}: Presupuesto vs Real ({n} meses)',
    sinDatosPresupuesto: 'Sin datos de presupuesto',
    dondeSeVa: 'Dónde se va el dinero ({year})',
    delGasto: 'del gasto',
    gasto: 'Gasto',
    sinGastosRegistrados: 'Sin gastos registrados',
    realDe: 'Real: {sub}',
    sinCategorias: 'Sin categorías',
    esteAnioVsAnterior: 'Este año vs. el anterior ({a} vs. {b})',
    ahorro: 'Ahorro',
    primerosMeses: 'primeros {n} meses',
    sinDatosAnioAnterior: 'No hay datos de {year}. Cuando existan, aquí verás la comparación mes a mes.',
    modoPersonalizacion: 'Modo personalización: sube, baja, ensancha u oculta cada bloque. Se guarda en tu cuenta.',
    bloquesVisibles: '{n} bloques visibles',
    bloquesOcultos: '{n} ocultos',
    anadirBloque: '+ Añadir bloque…',
    restablecer: 'Restablecer',
    restablecerConfirm: '¿Volver a la disposición inicial del dashboard?',
    listo: 'Listo',
    personalizar: 'Personalizar',
    subir: 'Subir',
    bajar: 'Bajar',
    mediaAnchura: 'Media anchura',
    anchuraCompleta: 'Anchura completa',
    ocultar: 'Ocultar',
    sinBloques: 'No hay bloques visibles. Pulsa "Personalizar" y añade los que quieras.',
    // Dashboard (presupuesto)
    total: 'Total',
    puntualAviso: 'Por favor, selecciona al menos un mes e introduce un importe válido.',
    presupuestoAnual: 'PRESUPUESTO ANUAL',
    planificaFinanzas: 'Planifica tus finanzas mensuales para {year}.',
    remanenteMensual: 'REMANENTE MENSUAL',
    desbloquearEdicion: 'Desbloquear Edición',
    bloquearEdicion: 'Bloquear Edición',
    puntualNombrePlaceholder: 'Nombre (ej. Paga extra)',
    seleccionarMeses: 'Seleccionar meses:',
    eliminarTodosMeses: 'Eliminar en todos los meses',
    totalEnAnio: 'Total en {year}: {importe}',
    delPresupuesto: 'del presupuesto',
    // Seguimiento mensual
    estimado: 'Estimado',
    gastadoSobreMes: 'gastado sobre mes',
    completaCampos: 'Completa todos los campos',
    subNoExiste: '"{sub}" no existe en {seccion} en {year}. Elige otra subcategoría.',
    cuotasAutomaticas: 'Las cuotas de préstamos se generan automáticamente. Para eliminarlas o modificarlas, ve a la pestaña de Préstamos.',
    // Seguimiento mensual: edición directa en la tabla
    smEstimadoAyuda: 'El estimado es el presupuesto mensual de {year} y se edita en la pestaña Presupuesto de esta sección (para todo el año).',
    smIrPresupuesto: 'Ir al presupuesto',
    smRealAyuda: 'Haz clic y escribe el total real del mes: se crea o ajusta un movimiento para que cuadre.',
    smAjuste: 'Ajuste',
    smConceptoOpcional: 'Concepto (opcional)',
    smMovimientosDe: 'Movimientos de {sub}',
    smSinMovimientos: 'Sin movimientos este mes.',
    smCuotaAuto: 'Cuota automática del préstamo',
    smVer: 'Ver movimientos',
    smOcultar: 'Ocultar movimientos',
    smGuardar: 'Guardar',
    smEditarAyuda: 'Haz clic para editar',
    smPuntuales: 'puntuales',
    modoSeguimiento: 'Seguimiento',
    // Revisión de inicio de año (pestaña Presupuesto)
    revTitulo: 'Revisión de inicio de año: presupuesto {year}',
    revDesc: 'Compara el presupuesto de {year} con lo que ingresaste y gastaste de media al mes en {anterior} ({meses} meses con datos) y actualiza tus expectativas.',
    revPresupuesto: 'Presupuesto {year}',
    revMediaReal: 'Media real {anterior}',
    revUsar: 'Usar',
    revAplicarTodo: 'Aplicar las medias reales',
    revRevisado: 'Ya lo he revisado',
    revConfirmar: '¿Poner como presupuesto de {year} la media mensual real de {anterior} en todas las categorías con datos?',
    revSinDatos: 'No hay movimientos en {anterior} con los que comparar.',
    revBanner: 'Año nuevo, expectativas nuevas: revisa el presupuesto de {year} con los datos reales de {anterior}.',
    revBannerBtn: 'Revisar presupuesto',
    smAyudaTabla: 'Haz clic en una cifra real para cambiarla, y en el nombre de una categoría (▸) para ver, añadir o editar sus movimientos. El estimado se edita en la pestaña Presupuesto (arriba).',
    // Patrimonio
    seleccionarMesMovil: 'Seleccionar mes a visualizar/editar:',
    // Préstamos
    prestamoDuplicado: 'Ya hay un préstamo llamado "{nombre}". Usa otro nombre.',
    revisaPrestamo: 'Revisa el importe, el número de cuotas y la fecha de inicio.',
    cuotaFueraCuadro: 'El préstamo termina en la cuota {n} (las amortizaciones anticipadas lo acortan). Elige una cuota entre 1 y {n}.',
    eliminarAmortConfirm: '¿Eliminar amortización anticipada?',
    ejHipoteca: 'Ej: Hipoteca',
    amortAnticipada: 'Amortización Anticipada',
    frances: 'FRANCÉS',
    extra: 'Extra',
    extrasFueraCuadro: 'Amortizaciones anticipadas fuera del cuadro (el préstamo termina en la cuota {n}, así que no se aplican):',
    cuotaN: 'Cuota {n}',
    nuevaAmortAnticipada: 'Nueva Amortización Anticipada',
    numMesCuota: 'Nº Mes (Cuota)',
    importeExtra: 'Importe extra ({moneda})',
    aplicar: 'Aplicar',
    ej12: 'Ej: 12',
    // Configuración
    perfilActualizado: 'Perfil actualizado con éxito',
    usuario: 'Usuario',
    editarPerfil: 'Editar Perfil',
    informacionBasica: 'INFORMACIÓN BÁSICA',
    nombrePublico: 'NOMBRE PÚBLICO',
    ejNombre: 'Ej. Juan Pérez',
    guardarPerfil: 'Guardar Perfil',
    personalizarAvatar: 'PERSONALIZAR AVATAR',
    pulsaEditarPerfil: 'Pulsa en **Editar Perfil** para cambiar tu nombre público o elegir un nuevo avatar.',
    visibilidadSecciones: 'Visibilidad de Secciones',
    visibilidadSeccionesDesc: 'Personaliza tu barra lateral ocultando las secciones que no utilizas a diario.',
    visible: 'VISIBLE',
    oculto: 'OCULTO',
    mostrar: 'MOSTRAR',
    ocultarMayus: 'OCULTAR',
    categoriasPresupuestoVisibles: 'Categorías de Presupuesto Visibles',
    categoriasPresupuestoDesc: 'Elige qué bloques del presupuesto anual quieres ver en Seguimiento Mensual → Presupuesto.',
    lanzarTutorial: 'Lanzar Tutorial',
    moneda: 'Moneda',
    monedaAyuda: 'Solo cambia cómo se muestran los importes; no convierte las cantidades que ya has guardado.',
    automaticoAnio: 'Automático (año en curso)',
    aniosNuevosAyuda: 'Los años nuevos se crean solos al seleccionarlos en la barra superior, heredando las categorías, el presupuesto y los saldos del año anterior. Después, cada año guarda sus propios cambios.',
    modificaCategoriasPara: 'Modifica las categorías para **{year}** y años posteriores.',
    usaSelectorAnio: 'Utiliza el selector de año en la barra superior para editar un año en concreto.',
    renombrar: 'Renombrar "{nombre}"',
    seModificaraEn: 'Se modificará en presupuestos, transacciones y patrimonio.',
    guardar: 'Guardar',
    eliminarSub: '¿Eliminar **{sub}**?',
    // Trading
    resultadoNeto: 'Resultado Neto (Realizado)',
    brutoComis: 'Bruto: {bruto} | Comis: {comis}',
    estadisticas: 'Estadísticas',
    ratio: 'Ratio',
    posicionesAbiertas: 'Posiciones Abiertas',
    deTransacciones: 'De {n} transacciones',
    curvaEquidad: 'Curva de Equidad (PnL Acumulado)',
    posicionesActuales: 'Posiciones Actuales',
    activo: 'Activo',
    tipo: 'Tipo',
    cantidad: 'Cantidad',
    precioAvg: 'Precio Avg',
    nuevaOperacion: 'Nueva Operación',
    accion: 'Acción',
    direccion: 'Dirección',
    precio: 'Precio',
    comisiones: 'Comisiones',
    historialOperaciones: 'Historial de Operaciones',
    indicaFecha: 'Indica la fecha de la operación.',
    indicaActivo: 'Indica activo, precio y cantidad.',
    COMPRA: 'COMPRA',
    VENTA: 'VENTA',
    // Análisis
    vpnTir: 'VPN / TIR',
    interesCompuesto: 'Interés Compuesto',
    proyectoRentable: '¡Adelante! Proyecto rentable.',
    destruccionValor: '¡Alto! Destrucción de valor.',
    neutro: 'Indiferente / Neutro.',
    configProyecto: 'Configuración del Proyecto',
    inversionInicial: 'Inversión inicial ({moneda})',
    tasaDescuento: 'Tasa Descuento (%)',
    aniosPeriodos: 'Años/Periodos',
    resultadoAnalisis: 'Resultado del Análisis',
    vpnLargo: 'Valor Presente Neto (VPN)',
    tirLargo: 'Tasa Interna de Retorno (TIR)',
    flujosCaja: 'Flujos de caja futuros ({moneda})',
    anioN: 'Año {n}',
    queEsVpn: '¿Qué significa el VPN?',
    vpnExplica: 'Trae todos los flujos futuros al valor de **HOY** restando la inflación y el costo de oportunidad.',
    vpn: 'VPN',
    vpnPositivoTexto: 'Ganas dinero real por encima de tu rentabilidad exigida.',
    vpnNegativoTexto: 'Estás perdiendo poder adquisitivo o ganando menos que el mínimo.',
    queEsTir: '¿Qué significa la TIR?',
    tirExplica: 'Es la rentabilidad porcentual anual que genera el proyecto por sí mismo.',
    tirComparacion: 'Si tu **TIR ({tirVal}%)** es mayor que tu **Tasa de Descuento ({tdVal}%)**, el proyecto vale la pena.',
    configAhorro: 'Configuración de Ahorro',
    balanceInicial: 'Balance Inicial',
    contribucionMensual: 'Contribución Mensual',
    rentabilidadAnual: 'Rentabilidad Anual (%)',
    anios: 'Años',
    resultadoProyectado: 'Resultado Proyectado',
    capitalFinal: 'Capital Final',
    interesesGenerados: 'Intereses Generados',
    hasInvertido: 'Has invertido un total de **{total}**. El interés compuesto ha multiplicado tu capital por **{x}x**.',
    crecimientoInversion: 'Crecimiento de la Inversión',
    anterior: '← Anterior',
    siguiente: 'Siguiente →',
    paginaDe: 'Página {a} de {b}',
    // Gestión
    desconocido: 'Desconocido',
    csvUsuario: 'Usuario',
    csvEmail: 'Email',
    csvInicio: 'Inicio',
    csvFin: 'Fin',
    csvDuracion: 'Duración (min)',
    sesionActiva: 'Sesión Activa',
    errorGuardarUsuario: 'Error al guardar usuario: {msg}',
    noBloquearAdmin: 'No puedes bloquear a un administrador',
    bloquearConfirm: '¿Bloquear a {nombre}? No podrá guardar cambios hasta que lo desbloquees.',
    desbloquearConfirm: '¿Desbloquear a {nombre}?',
    errorActualizarUsuario: 'Error al actualizar el usuario: {msg}',
    datosCuenta: 'Datos de Cuenta',
    nombre: 'Nombre',
    email: 'Email',
    emailGestionadoAuth: 'El email lo gestiona Firebase Auth',
    pagadoHasta: 'Pagado hasta',
    pruebaHasta: 'Prueba hasta {fecha}. ',
    sinPrueba: 'Sin prueba registrada. ',
    dejaloVacio: 'Déjalo vacío para dejarlo sin pagar.',
    rolGlobal: 'Rol Global',
    rolUsuarioPermisos: 'Usuario (Basado en Permisos)',
    rolAdminTodo: 'Administrador (Todo permitido)',
    permisosEspecificos: 'Permisos Específicos',
    guardarCambios: 'Guardar Cambios',
    estadoRealtime: 'Estado Realtime',
    usuariosHoy: 'usuarios hoy',
    historicoTrafico: 'Histórico de Tráfico',
    dias7: '7 DÍAS',
    dias30: '30 DÍAS',
    dias90: '90 DÍAS',
    exportarCsv: 'Exportar Auditoría CSV',
    tendenciaActividad: 'Tendencia de Actividad (30 días)',
    rankingEngagement: 'Ranking de Engagement',
    sesiones: 'Sesiones',
    tiempoTotal: 'Tiempo Total',
    min: 'min',
    usuariosSistema: 'Usuarios del Sistema',
    gestionIdentidades: 'Gestión de identidades y privilegios granulares.',
    cuentasSeCrean: 'Las cuentas se crean cuando el usuario se registra en la web. Aquí se editan nombre, rol, permisos y pagos, y se bloquean o desbloquean.',
    rolPermisos: 'Rol / Permisos',
    adminTotal: 'ADMIN TOTAL',
    sinAccesos: 'Sin accesos',
    bloqueado: 'BLOQUEADO',
    editar: 'Editar',
    desbloquear: 'Desbloquear',
    bloquear: 'Bloquear',
    auditoriaErrores: 'Auditoría de Errores Críticos (Firebase)',
    auditoriaErroresDesc: 'Registro de fallos en sincronización o base de datos reportados por la plataforma.',
    sinErrores: 'No se han registrado errores en el sistema.',
    fechaHora: 'Fecha y Hora',
    operacion: 'Operación',
    mensajeError: 'Mensaje de Error',
    afectado: 'Afectado',
    // ─── Contraseña y verificación (Configuración → Perfil) ───
    passTitulo: 'CONTRASEÑA Y SEGURIDAD',
    passActual: 'Contraseña actual',
    passNueva: 'Nueva contraseña',
    passRepetir: 'Repetir nueva contraseña',
    passGuardar: 'Cambiar contraseña',
    passCrear: 'Crear contraseña',
    passCrearTexto: 'Tu cuenta entra con Google y aún no tiene contraseña: crea una para poder entrar también con tu correo.',
    passOk: 'Contraseña actualizada.',
    passNoCoincide: 'Las contraseñas no coinciden.',
    passCorta: 'La contraseña debe tener al menos 8 caracteres.',
    passActualMal: 'La contraseña actual no es correcta.',
    passError: 'No se pudo cambiar la contraseña: {msg}',
    passVerificado: 'Correo verificado',
    passSinVerificar: 'Correo sin verificar',
  },
  en: {
    analysis: 'Analysis',
    users: 'Management',
    trading: 'Trading',
    rolAdmin: 'ADMIN',
    rolUsuario: 'USER',
    rolAdministrador: 'ADMINISTRATOR',
    accesoRestringido: 'Access Restricted',
    elUsuario: 'The user',
    sinPermisoPara: 'does not have permission to access',
    volverInicio: 'Back to Home',
    noGuardado: 'Not saved.',
    cerrar: 'Close',
    precioMes: '$2.50 / month (early-access price)',
    subTrialEnded: 'Your free trial has ended',
    subDaysLeftOne: 'You have 1 day of trial left',
    subDaysLeft: 'You have {n} days of trial left',
    subExpiredBody: 'You can keep viewing and exporting your data, but not add or change anything. Activate your account for {precio}.',
    subTrialBody: 'When it ends you will still be able to view your data, but not edit it. {precio}.',
    errBloqueado: 'Your account is blocked: changes cannot be saved. Contact the administrator.',
    errPruebaTerminada: 'Your free trial has ended: changes are not saved. Activate your account to keep editing.',
    errPermisos: 'Firestore rejected the change due to missing permissions. The last saved version has been restored.',
    errSinConexion: 'No connection: the change could not be saved. The last saved version has been restored.',
    errGuardar: 'The change could not be saved ({msg}). The last saved version has been restored.',
    errDesconocido: 'unknown error',
    errSync: 'Sync error: {msg}',
    nombreSinSeparador: 'The name cannot contain the character "{sep}".',
    yaExisteAnio: 'It already exists in this year',
    yaExisteEn: '"{nombre}" already exists in {seccion} (in this year, a later one or the settings).',
    addSubPlaceholder: 'Add subcategory...',
    wKpis: 'Year summary (income, expenses, savings)',
    wSalud: 'Financial health',
    wFlujo: 'Monthly income vs. expenses',
    wDistribucion: 'Expense distribution',
    wAhorroAcumulado: 'Cumulative savings: plan vs. actual',
    wObjetivo: 'Annual savings goal',
    wPresupuestoIngresos: 'Income: budget vs. actual',
    wPresupuestoGastos: 'Expenses: budget vs. actual',
    wTopGastos: 'Where the money goes (top expenses)',
    wCategoria: 'Evolution of a category',
    wAhorroMensual: 'Savings per month',
    wComparativa: 'This year vs. last year',
    wPatrimonio: 'Net worth',
    wPrestamos: 'Loan progress',
    wTrading: 'Trading summary',
    sinIngresosRegistrados: 'No income recorded',
    saludHasta: '(until {mes})',
    tasaAhorro: 'Savings rate',
    tasaAhorroNota: 'The share of your income you save. Reference: 20% or more.',
    fondoEmergencia: 'Emergency fund',
    meses: 'months',
    fondoNota: '{cats} over the average monthly expense. Reference: 3 to 6 months.',
    cargaDeuda: 'Debt load',
    cargaDeudaNota: 'Loan payments over the average monthly income. Reference: below 30%.',
    sinDatos: 'No data',
    planSegunPresupuesto: 'Plan (according to budget)',
    objetivoPara: 'Goal for {year} ({moneda})',
    llevasDe: 'You have saved **{a}** of {b}.',
    ritmoActual: 'At the current pace ({ritmo} per month) you will end the year with **{proy}**:',
    vasPorDelante: 'you are ahead of the goal.',
    teFaltarian: 'you would be {x} short.',
    objetivoCumplido: 'Goal achieved.',
    faltaron: '{x} short.',
    objetivoAyuda: 'Enter how much you want to save this year and you will see the progress and a year-end projection based on your current pace.',
    presupuestoVsRealN: '{seccion}: Budget vs Actual ({n} months)',
    sinDatosPresupuesto: 'No budget data',
    dondeSeVa: 'Where the money goes ({year})',
    delGasto: 'of expenses',
    gasto: 'Expense',
    sinGastosRegistrados: 'No expenses recorded',
    realDe: 'Actual: {sub}',
    sinCategorias: 'No categories',
    esteAnioVsAnterior: 'This year vs. last year ({a} vs. {b})',
    ahorro: 'Savings',
    primerosMeses: 'first {n} months',
    sinDatosAnioAnterior: 'No data for {year}. When there is, you will see the month-by-month comparison here.',
    modoPersonalizacion: 'Customisation mode: move, widen or hide each block. It is saved to your account.',
    bloquesVisibles: '{n} visible blocks',
    bloquesOcultos: '{n} hidden',
    anadirBloque: '+ Add block…',
    restablecer: 'Reset',
    restablecerConfirm: 'Return to the default dashboard layout?',
    listo: 'Done',
    personalizar: 'Customise',
    subir: 'Move up',
    bajar: 'Move down',
    mediaAnchura: 'Half width',
    anchuraCompleta: 'Full width',
    ocultar: 'Hide',
    sinBloques: 'No visible blocks. Press "Customise" and add the ones you want.',
    total: 'Total',
    puntualAviso: 'Please select at least one month and enter a valid amount.',
    presupuestoAnual: 'ANNUAL BUDGET',
    planificaFinanzas: 'Plan your monthly finances for {year}.',
    remanenteMensual: 'MONTHLY REMAINDER',
    desbloquearEdicion: 'Unlock Editing',
    bloquearEdicion: 'Lock Editing',
    puntualNombrePlaceholder: 'Name (e.g. Bonus)',
    seleccionarMeses: 'Select months:',
    eliminarTodosMeses: 'Delete in all months',
    totalEnAnio: 'Total in {year}: {importe}',
    delPresupuesto: 'of the budget',
    estimado: 'Estimated',
    gastadoSobreMes: 'spent of the month',
    completaCampos: 'Fill in all fields',
    subNoExiste: '"{sub}" does not exist in {seccion} in {year}. Choose another subcategory.',
    cuotasAutomaticas: 'Loan payments are generated automatically. To delete or change them, go to the Loans tab.',
    smEstimadoAyuda: 'The estimate is the monthly budget for {year}; it is edited in the Budget tab of this section (for the whole year).',
    smIrPresupuesto: 'Go to budget',
    smRealAyuda: 'Click and type the real total for the month: a transaction is created or adjusted so it matches.',
    smAjuste: 'Adjustment',
    smConceptoOpcional: 'Note (optional)',
    smMovimientosDe: 'Transactions for {sub}',
    smSinMovimientos: 'No transactions this month.',
    smCuotaAuto: 'Automatic loan payment',
    smVer: 'Show transactions',
    smOcultar: 'Hide transactions',
    smGuardar: 'Save',
    smEditarAyuda: 'Click to edit',
    smPuntuales: 'one-time',
    modoSeguimiento: 'Tracking',
    revTitulo: 'Start-of-year review: {year} budget',
    revDesc: 'Compare the {year} budget with your average monthly income and spending in {anterior} ({meses} months with data) and update your expectations.',
    revPresupuesto: 'Budget {year}',
    revMediaReal: 'Actual average {anterior}',
    revUsar: 'Use',
    revAplicarTodo: 'Apply the actual averages',
    revRevisado: 'Already reviewed',
    revConfirmar: 'Set the {anterior} actual monthly average as the {year} budget for every category with data?',
    revSinDatos: 'There are no transactions in {anterior} to compare with.',
    revBanner: 'New year, new expectations: review your {year} budget against your {anterior} actuals.',
    revBannerBtn: 'Review budget',
    smAyudaTabla: 'Click a real figure to change it, and a category name (▸) to see, add or edit its transactions. The estimate is edited in the Budget tab (top).',
    seleccionarMesMovil: 'Select month to view/edit:',
    prestamoDuplicado: 'There is already a loan called "{nombre}". Use another name.',
    revisaPrestamo: 'Check the amount, the number of installments and the start date.',
    cuotaFueraCuadro: 'The loan ends at installment {n} (early repayments shorten it). Choose an installment between 1 and {n}.',
    eliminarAmortConfirm: 'Delete early repayment?',
    ejHipoteca: 'E.g. Mortgage',
    amortAnticipada: 'Early Repayment',
    frances: 'FRENCH',
    extra: 'Extra',
    extrasFueraCuadro: 'Early repayments outside the schedule (the loan ends at installment {n}, so they are not applied):',
    cuotaN: 'Installment {n}',
    nuevaAmortAnticipada: 'New Early Repayment',
    numMesCuota: 'Month No. (Installment)',
    importeExtra: 'Extra amount ({moneda})',
    aplicar: 'Apply',
    ej12: 'E.g. 12',
    perfilActualizado: 'Profile updated successfully',
    usuario: 'User',
    editarPerfil: 'Edit Profile',
    informacionBasica: 'BASIC INFORMATION',
    nombrePublico: 'PUBLIC NAME',
    ejNombre: 'E.g. John Smith',
    guardarPerfil: 'Save Profile',
    personalizarAvatar: 'CUSTOMISE AVATAR',
    pulsaEditarPerfil: 'Press **Edit Profile** to change your public name or choose a new avatar.',
    visibilidadSecciones: 'Section Visibility',
    visibilidadSeccionesDesc: 'Customise your sidebar by hiding the sections you do not use daily.',
    visible: 'VISIBLE',
    oculto: 'HIDDEN',
    mostrar: 'SHOW',
    ocultarMayus: 'HIDE',
    categoriasPresupuestoVisibles: 'Visible Budget Categories',
    categoriasPresupuestoDesc: 'Choose which blocks of the annual budget you want to see in Monthly Tracker → Budget.',
    lanzarTutorial: 'Launch Tutorial',
    moneda: 'Currency',
    monedaAyuda: 'It only changes how amounts are displayed; it does not convert the amounts you have already saved.',
    automaticoAnio: 'Automatic (current year)',
    aniosNuevosAyuda: 'New years are created automatically when you select them in the top bar, inheriting the categories, budget and balances of the previous year. After that, each year keeps its own changes.',
    modificaCategoriasPara: 'Edit the categories for **{year}** and later years.',
    usaSelectorAnio: 'Use the year selector in the top bar to edit a specific year.',
    renombrar: 'Rename "{nombre}"',
    seModificaraEn: 'It will be changed in budgets, transactions and net worth.',
    guardar: 'Save',
    eliminarSub: 'Delete **{sub}**?',
    resultadoNeto: 'Net Result (Realised)',
    brutoComis: 'Gross: {bruto} | Fees: {comis}',
    estadisticas: 'Statistics',
    ratio: 'Ratio',
    posicionesAbiertas: 'Open Positions',
    deTransacciones: 'Of {n} transactions',
    curvaEquidad: 'Equity Curve (Cumulative PnL)',
    posicionesActuales: 'Current Positions',
    activo: 'Asset',
    tipo: 'Type',
    cantidad: 'Quantity',
    precioAvg: 'Avg Price',
    nuevaOperacion: 'New Trade',
    accion: 'Action',
    direccion: 'Direction',
    precio: 'Price',
    comisiones: 'Fees',
    historialOperaciones: 'Trade History',
    indicaFecha: 'Enter the trade date.',
    indicaActivo: 'Enter asset, price and quantity.',
    COMPRA: 'BUY',
    VENTA: 'SELL',
    vpnTir: 'NPV / IRR',
    interesCompuesto: 'Compound Interest',
    proyectoRentable: 'Go ahead! Profitable project.',
    destruccionValor: 'Stop! Value destruction.',
    neutro: 'Indifferent / Neutral.',
    configProyecto: 'Project Setup',
    inversionInicial: 'Initial investment ({moneda})',
    tasaDescuento: 'Discount Rate (%)',
    aniosPeriodos: 'Years/Periods',
    resultadoAnalisis: 'Analysis Result',
    vpnLargo: 'Net Present Value (NPV)',
    tirLargo: 'Internal Rate of Return (IRR)',
    flujosCaja: 'Future cash flows ({moneda})',
    anioN: 'Year {n}',
    queEsVpn: 'What does NPV mean?',
    vpnExplica: 'It brings all future flows to **TODAY\'s** value, discounting inflation and the opportunity cost.',
    vpn: 'NPV',
    vpnPositivoTexto: 'You earn real money above your required return.',
    vpnNegativoTexto: 'You are losing purchasing power or earning less than the minimum.',
    queEsTir: 'What does IRR mean?',
    tirExplica: 'It is the annual percentage return the project generates by itself.',
    tirComparacion: 'If your **IRR ({tirVal}%)** is higher than your **Discount Rate ({tdVal}%)**, the project is worth it.',
    configAhorro: 'Savings Setup',
    balanceInicial: 'Initial Balance',
    contribucionMensual: 'Monthly Contribution',
    rentabilidadAnual: 'Annual Return (%)',
    anios: 'Years',
    resultadoProyectado: 'Projected Result',
    capitalFinal: 'Final Capital',
    interesesGenerados: 'Interest Earned',
    hasInvertido: 'You have invested a total of **{total}**. Compound interest has multiplied your capital by **{x}x**.',
    crecimientoInversion: 'Investment Growth',
    anterior: '← Previous',
    siguiente: 'Next →',
    paginaDe: 'Page {a} of {b}',
    desconocido: 'Unknown',
    csvUsuario: 'User',
    csvEmail: 'Email',
    csvInicio: 'Start',
    csvFin: 'End',
    csvDuracion: 'Duration (min)',
    sesionActiva: 'Active Session',
    errorGuardarUsuario: 'Error saving user: {msg}',
    noBloquearAdmin: 'You cannot block an administrator',
    bloquearConfirm: 'Block {nombre}? They will not be able to save changes until you unblock them.',
    desbloquearConfirm: 'Unblock {nombre}?',
    errorActualizarUsuario: 'Error updating the user: {msg}',
    datosCuenta: 'Account Details',
    nombre: 'Name',
    email: 'Email',
    emailGestionadoAuth: 'The email is managed by Firebase Auth',
    pagadoHasta: 'Paid until',
    pruebaHasta: 'Trial until {fecha}. ',
    sinPrueba: 'No trial recorded. ',
    dejaloVacio: 'Leave it empty to mark as unpaid.',
    rolGlobal: 'Global Role',
    rolUsuarioPermisos: 'User (Permission-based)',
    rolAdminTodo: 'Administrator (Everything allowed)',
    permisosEspecificos: 'Specific Permissions',
    guardarCambios: 'Save Changes',
    estadoRealtime: 'Realtime Status',
    usuariosHoy: 'users today',
    historicoTrafico: 'Traffic History',
    dias7: '7 DAYS',
    dias30: '30 DAYS',
    dias90: '90 DAYS',
    exportarCsv: 'Export Audit CSV',
    tendenciaActividad: 'Activity Trend (30 days)',
    rankingEngagement: 'Engagement Ranking',
    sesiones: 'Sessions',
    tiempoTotal: 'Total Time',
    min: 'min',
    usuariosSistema: 'System Users',
    gestionIdentidades: 'Identity and granular privilege management.',
    cuentasSeCrean: 'Accounts are created when the user signs up on the website. Here you edit name, role, permissions and payments, and block or unblock.',
    rolPermisos: 'Role / Permissions',
    adminTotal: 'FULL ADMIN',
    sinAccesos: 'No access',
    bloqueado: 'BLOCKED',
    editar: 'Edit',
    desbloquear: 'Unblock',
    bloquear: 'Block',
    auditoriaErrores: 'Critical Error Audit (Firebase)',
    auditoriaErroresDesc: 'Log of sync or database failures reported by the platform.',
    sinErrores: 'No errors have been recorded in the system.',
    fechaHora: 'Date and Time',
    operacion: 'Operation',
    mensajeError: 'Error Message',
    afectado: 'Affected',
    // ─── Password and verification (Settings → Profile) ───
    passTitulo: 'PASSWORD AND SECURITY',
    passActual: 'Current password',
    passNueva: 'New password',
    passRepetir: 'Repeat new password',
    passGuardar: 'Change password',
    passCrear: 'Create password',
    passCrearTexto: 'Your account signs in with Google and has no password yet: create one to also sign in with your email.',
    passOk: 'Password updated.',
    passNoCoincide: 'The passwords do not match.',
    passCorta: 'The password must be at least 8 characters long.',
    passActualMal: 'The current password is not correct.',
    passError: 'Could not change the password: {msg}',
    passVerificado: 'Email verified',
    passSinVerificar: 'Email not verified',
  },
  de: {
    analysis: 'Analyse',
    users: 'Verwaltung',
    trading: 'Trading',
    rolAdmin: 'ADMIN',
    rolUsuario: 'BENUTZER',
    rolAdministrador: 'ADMINISTRATOR',
    accesoRestringido: 'Zugriff eingeschränkt',
    elUsuario: 'Der Benutzer',
    sinPermisoPara: 'hat keine Berechtigung für',
    volverInicio: 'Zurück zum Start',
    noGuardado: 'Nicht gespeichert.',
    cerrar: 'Schließen',
    precioMes: '2,50 $ / Monat (Early-Access-Preis)',
    subTrialEnded: 'Ihre kostenlose Testphase ist abgelaufen',
    subDaysLeftOne: 'Ihnen bleibt noch 1 Testtag',
    subDaysLeft: 'Ihnen bleiben noch {n} Testtage',
    subExpiredBody: 'Sie können Ihre Daten weiterhin ansehen und exportieren, aber nichts hinzufügen oder ändern. Aktivieren Sie Ihr Konto für {precio}.',
    subTrialBody: 'Danach können Sie Ihre Daten weiterhin ansehen, aber nicht bearbeiten. {precio}.',
    errBloqueado: 'Ihr Konto ist gesperrt: Änderungen können nicht gespeichert werden. Wenden Sie sich an den Administrator.',
    errPruebaTerminada: 'Ihre Testphase ist abgelaufen: Änderungen werden nicht gespeichert. Aktivieren Sie Ihr Konto, um weiter zu bearbeiten.',
    errPermisos: 'Firestore hat die Änderung wegen fehlender Berechtigungen abgelehnt. Die zuletzt gespeicherte Version wurde wiederhergestellt.',
    errSinConexion: 'Keine Verbindung: Die Änderung konnte nicht gespeichert werden. Die zuletzt gespeicherte Version wurde wiederhergestellt.',
    errGuardar: 'Die Änderung konnte nicht gespeichert werden ({msg}). Die zuletzt gespeicherte Version wurde wiederhergestellt.',
    errDesconocido: 'unbekannter Fehler',
    errSync: 'Synchronisierungsfehler: {msg}',
    nombreSinSeparador: 'Der Name darf das Zeichen "{sep}" nicht enthalten.',
    yaExisteAnio: 'Existiert in diesem Jahr bereits',
    yaExisteEn: '"{nombre}" existiert bereits in {seccion} (in diesem Jahr, einem späteren oder in den Einstellungen).',
    addSubPlaceholder: 'Unterkategorie hinzufügen...',
    wKpis: 'Jahresübersicht (Einkommen, Ausgaben, Ersparnisse)',
    wSalud: 'Finanzielle Gesundheit',
    wFlujo: 'Monatliches Einkommen vs. Ausgaben',
    wDistribucion: 'Ausgabenverteilung',
    wAhorroAcumulado: 'Kumulierte Ersparnisse: Plan vs. Ist',
    wObjetivo: 'Jährliches Sparziel',
    wPresupuestoIngresos: 'Einkommen: Budget vs. Ist',
    wPresupuestoGastos: 'Ausgaben: Budget vs. Ist',
    wTopGastos: 'Wohin das Geld geht (Top-Ausgaben)',
    wCategoria: 'Entwicklung einer Kategorie',
    wAhorroMensual: 'Ersparnisse pro Monat',
    wComparativa: 'Dieses Jahr vs. Vorjahr',
    wPatrimonio: 'Nettovermögen',
    wPrestamos: 'Kreditfortschritt',
    wTrading: 'Trading-Übersicht',
    sinIngresosRegistrados: 'Kein Einkommen erfasst',
    saludHasta: '(bis {mes})',
    tasaAhorro: 'Sparquote',
    tasaAhorroNota: 'Der Anteil Ihres Einkommens, den Sie sparen. Richtwert: 20 % oder mehr.',
    fondoEmergencia: 'Notfallfonds',
    meses: 'Monate',
    fondoNota: '{cats} geteilt durch die durchschnittlichen Monatsausgaben. Richtwert: 3 bis 6 Monate.',
    cargaDeuda: 'Schuldenlast',
    cargaDeudaNota: 'Kreditraten im Verhältnis zum durchschnittlichen Monatseinkommen. Richtwert: unter 30 %.',
    sinDatos: 'Keine Daten',
    planSegunPresupuesto: 'Plan (laut Budget)',
    objetivoPara: 'Ziel für {year} ({moneda})',
    llevasDe: 'Sie haben **{a}** von {b} gespart.',
    ritmoActual: 'Im aktuellen Tempo ({ritmo} pro Monat) beenden Sie das Jahr mit **{proy}**:',
    vasPorDelante: 'Sie liegen vor dem Ziel.',
    teFaltarian: 'es würden {x} fehlen.',
    objetivoCumplido: 'Ziel erreicht.',
    faltaron: 'Es fehlten {x}.',
    objetivoAyuda: 'Geben Sie ein, wie viel Sie dieses Jahr sparen möchten, und Sie sehen den Fortschritt und eine Prognose zum Jahresende auf Basis Ihres aktuellen Tempos.',
    presupuestoVsRealN: '{seccion}: Budget vs. Ist ({n} Monate)',
    sinDatosPresupuesto: 'Keine Budgetdaten',
    dondeSeVa: 'Wohin das Geld geht ({year})',
    delGasto: 'der Ausgaben',
    gasto: 'Ausgabe',
    sinGastosRegistrados: 'Keine Ausgaben erfasst',
    realDe: 'Ist: {sub}',
    sinCategorias: 'Keine Kategorien',
    esteAnioVsAnterior: 'Dieses Jahr vs. Vorjahr ({a} vs. {b})',
    ahorro: 'Ersparnisse',
    primerosMeses: 'erste {n} Monate',
    sinDatosAnioAnterior: 'Keine Daten für {year}. Sobald welche vorliegen, sehen Sie hier den Vergleich Monat für Monat.',
    modoPersonalizacion: 'Anpassungsmodus: Verschieben, verbreitern oder verbergen Sie jeden Block. Wird in Ihrem Konto gespeichert.',
    bloquesVisibles: '{n} sichtbare Blöcke',
    bloquesOcultos: '{n} verborgen',
    anadirBloque: '+ Block hinzufügen…',
    restablecer: 'Zurücksetzen',
    restablecerConfirm: 'Zur Standardanordnung des Dashboards zurückkehren?',
    listo: 'Fertig',
    personalizar: 'Anpassen',
    subir: 'Nach oben',
    bajar: 'Nach unten',
    mediaAnchura: 'Halbe Breite',
    anchuraCompleta: 'Volle Breite',
    ocultar: 'Verbergen',
    sinBloques: 'Keine sichtbaren Blöcke. Klicken Sie auf „Anpassen“ und fügen Sie die gewünschten hinzu.',
    total: 'Gesamt',
    puntualAviso: 'Bitte wählen Sie mindestens einen Monat und geben Sie einen gültigen Betrag ein.',
    presupuestoAnual: 'JAHRESBUDGET',
    planificaFinanzas: 'Planen Sie Ihre monatlichen Finanzen für {year}.',
    remanenteMensual: 'MONATLICHER RESTBETRAG',
    desbloquearEdicion: 'Bearbeitung freigeben',
    bloquearEdicion: 'Bearbeitung sperren',
    puntualNombrePlaceholder: 'Name (z. B. Sonderzahlung)',
    seleccionarMeses: 'Monate auswählen:',
    eliminarTodosMeses: 'In allen Monaten löschen',
    totalEnAnio: 'Gesamt in {year}: {importe}',
    delPresupuesto: 'des Budgets',
    estimado: 'Geschätzt',
    gastadoSobreMes: 'des Monats ausgegeben',
    completaCampos: 'Füllen Sie alle Felder aus',
    subNoExiste: '"{sub}" existiert in {seccion} im Jahr {year} nicht. Wählen Sie eine andere Unterkategorie.',
    cuotasAutomaticas: 'Kreditraten werden automatisch erzeugt. Um sie zu löschen oder zu ändern, gehen Sie zum Reiter Kredite.',
    smEstimadoAyuda: 'Die Schätzung ist das Monatsbudget {year}; sie wird im Reiter Budget dieses Bereichs bearbeitet (für das ganze Jahr).',
    smIrPresupuesto: 'Zum Budget',
    smRealAyuda: 'Klicken und den tatsächlichen Monatsbetrag eingeben: eine Buchung wird angelegt oder angepasst, damit es passt.',
    smAjuste: 'Anpassung',
    smConceptoOpcional: 'Notiz (optional)',
    smMovimientosDe: 'Buchungen von {sub}',
    smSinMovimientos: 'Keine Buchungen in diesem Monat.',
    smCuotaAuto: 'Automatische Kreditrate',
    smVer: 'Buchungen anzeigen',
    smOcultar: 'Buchungen ausblenden',
    smGuardar: 'Speichern',
    smEditarAyuda: 'Zum Bearbeiten klicken',
    smPuntuales: 'einmalig',
    modoSeguimiento: 'Verfolgung',
    revTitulo: 'Jahresbeginn-Check: Budget {year}',
    revDesc: 'Vergleichen Sie das Budget {year} mit Ihren durchschnittlichen monatlichen Einnahmen und Ausgaben in {anterior} ({meses} Monate mit Daten) und passen Sie Ihre Erwartungen an.',
    revPresupuesto: 'Budget {year}',
    revMediaReal: 'Ist-Durchschnitt {anterior}',
    revUsar: 'Übernehmen',
    revAplicarTodo: 'Ist-Durchschnitte übernehmen',
    revRevisado: 'Bereits geprüft',
    revConfirmar: 'Den tatsächlichen Monatsdurchschnitt von {anterior} als Budget {year} für alle Kategorien mit Daten übernehmen?',
    revSinDatos: 'In {anterior} gibt es keine Buchungen zum Vergleichen.',
    revBanner: 'Neues Jahr, neue Erwartungen: Prüfen Sie Ihr Budget {year} anhand der Ist-Werte von {anterior}.',
    revBannerBtn: 'Budget prüfen',
    smAyudaTabla: 'Klicken Sie auf einen Ist-Wert, um ihn zu ändern, und auf einen Kategorienamen (▸), um dessen Buchungen zu sehen, hinzuzufügen oder zu bearbeiten. Die Schätzung wird im Reiter Budget (oben) bearbeitet.',
    seleccionarMesMovil: 'Monat zum Anzeigen/Bearbeiten wählen:',
    prestamoDuplicado: 'Es gibt bereits einen Kredit namens "{nombre}". Verwenden Sie einen anderen Namen.',
    revisaPrestamo: 'Prüfen Sie den Betrag, die Anzahl der Raten und das Startdatum.',
    cuotaFueraCuadro: 'Der Kredit endet bei Rate {n} (Sondertilgungen verkürzen ihn). Wählen Sie eine Rate zwischen 1 und {n}.',
    eliminarAmortConfirm: 'Sondertilgung löschen?',
    ejHipoteca: 'z. B. Hypothek',
    amortAnticipada: 'Sondertilgung',
    frances: 'ANNUITÄT',
    extra: 'Extra',
    extrasFueraCuadro: 'Sondertilgungen außerhalb des Plans (der Kredit endet bei Rate {n}, daher werden sie nicht angewendet):',
    cuotaN: 'Rate {n}',
    nuevaAmortAnticipada: 'Neue Sondertilgung',
    numMesCuota: 'Monat Nr. (Rate)',
    importeExtra: 'Zusatzbetrag ({moneda})',
    aplicar: 'Anwenden',
    ej12: 'z. B. 12',
    perfilActualizado: 'Profil erfolgreich aktualisiert',
    usuario: 'Benutzer',
    editarPerfil: 'Profil bearbeiten',
    informacionBasica: 'GRUNDINFORMATIONEN',
    nombrePublico: 'ÖFFENTLICHER NAME',
    ejNombre: 'z. B. Max Mustermann',
    guardarPerfil: 'Profil speichern',
    personalizarAvatar: 'AVATAR ANPASSEN',
    pulsaEditarPerfil: 'Klicken Sie auf **Profil bearbeiten**, um Ihren öffentlichen Namen zu ändern oder einen neuen Avatar zu wählen.',
    visibilidadSecciones: 'Sichtbarkeit der Bereiche',
    visibilidadSeccionesDesc: 'Passen Sie Ihre Seitenleiste an, indem Sie Bereiche ausblenden, die Sie nicht täglich nutzen.',
    visible: 'SICHTBAR',
    oculto: 'VERBORGEN',
    mostrar: 'ANZEIGEN',
    ocultarMayus: 'AUSBLENDEN',
    categoriasPresupuestoVisibles: 'Sichtbare Budgetkategorien',
    categoriasPresupuestoDesc: 'Wählen Sie, welche Blöcke des Jahresbudgets in Monatsübersicht → Budget angezeigt werden.',
    lanzarTutorial: 'Tutorial starten',
    moneda: 'Währung',
    monedaAyuda: 'Ändert nur die Anzeige der Beträge; bereits gespeicherte Beträge werden nicht umgerechnet.',
    automaticoAnio: 'Automatisch (laufendes Jahr)',
    aniosNuevosAyuda: 'Neue Jahre werden automatisch angelegt, wenn Sie sie in der oberen Leiste auswählen; sie übernehmen Kategorien, Budget und Salden des Vorjahres. Danach speichert jedes Jahr seine eigenen Änderungen.',
    modificaCategoriasPara: 'Bearbeiten Sie die Kategorien für **{year}** und spätere Jahre.',
    usaSelectorAnio: 'Verwenden Sie die Jahresauswahl in der oberen Leiste, um ein bestimmtes Jahr zu bearbeiten.',
    renombrar: '"{nombre}" umbenennen',
    seModificaraEn: 'Wird in Budgets, Transaktionen und Vermögen geändert.',
    guardar: 'Speichern',
    eliminarSub: '**{sub}** löschen?',
    resultadoNeto: 'Nettoergebnis (realisiert)',
    brutoComis: 'Brutto: {bruto} | Gebühren: {comis}',
    estadisticas: 'Statistiken',
    ratio: 'Quote',
    posicionesAbiertas: 'Offene Positionen',
    deTransacciones: 'Von {n} Transaktionen',
    curvaEquidad: 'Kapitalkurve (kumulierter PnL)',
    posicionesActuales: 'Aktuelle Positionen',
    activo: 'Anlage',
    tipo: 'Typ',
    cantidad: 'Menge',
    precioAvg: 'Ø Preis',
    nuevaOperacion: 'Neue Transaktion',
    accion: 'Aktion',
    direccion: 'Richtung',
    precio: 'Preis',
    comisiones: 'Gebühren',
    historialOperaciones: 'Transaktionsverlauf',
    indicaFecha: 'Geben Sie das Datum der Transaktion an.',
    indicaActivo: 'Geben Sie Anlage, Preis und Menge an.',
    COMPRA: 'KAUF',
    VENTA: 'VERKAUF',
    vpnTir: 'Kapitalwert / IRR',
    interesCompuesto: 'Zinseszins',
    proyectoRentable: 'Los geht\'s! Rentables Projekt.',
    destruccionValor: 'Stopp! Wertvernichtung.',
    neutro: 'Indifferent / Neutral.',
    configProyecto: 'Projektkonfiguration',
    inversionInicial: 'Anfangsinvestition ({moneda})',
    tasaDescuento: 'Diskontsatz (%)',
    aniosPeriodos: 'Jahre/Perioden',
    resultadoAnalisis: 'Analyseergebnis',
    vpnLargo: 'Kapitalwert (NPV)',
    tirLargo: 'Interner Zinsfuß (IRR)',
    flujosCaja: 'Zukünftige Cashflows ({moneda})',
    anioN: 'Jahr {n}',
    queEsVpn: 'Was bedeutet der Kapitalwert?',
    vpnExplica: 'Er rechnet alle zukünftigen Zahlungsströme auf den **HEUTIGEN** Wert um, abzüglich Inflation und Opportunitätskosten.',
    vpn: 'NPV',
    vpnPositivoTexto: 'Sie verdienen real mehr als Ihre geforderte Rendite.',
    vpnNegativoTexto: 'Sie verlieren Kaufkraft oder verdienen weniger als das Minimum.',
    queEsTir: 'Was bedeutet der IRR?',
    tirExplica: 'Es ist die jährliche prozentuale Rendite, die das Projekt von sich aus erzielt.',
    tirComparacion: 'Wenn Ihr **IRR ({tirVal}%)** höher ist als Ihr **Diskontsatz ({tdVal}%)**, lohnt sich das Projekt.',
    configAhorro: 'Sparkonfiguration',
    balanceInicial: 'Anfangsguthaben',
    contribucionMensual: 'Monatlicher Beitrag',
    rentabilidadAnual: 'Jahresrendite (%)',
    anios: 'Jahre',
    resultadoProyectado: 'Prognostiziertes Ergebnis',
    capitalFinal: 'Endkapital',
    interesesGenerados: 'Erzielte Zinsen',
    hasInvertido: 'Sie haben insgesamt **{total}** investiert. Der Zinseszins hat Ihr Kapital um das **{x}-Fache** vervielfacht.',
    crecimientoInversion: 'Wachstum der Investition',
    anterior: '← Zurück',
    siguiente: 'Weiter →',
    paginaDe: 'Seite {a} von {b}',
    desconocido: 'Unbekannt',
    csvUsuario: 'Benutzer',
    csvEmail: 'E-Mail',
    csvInicio: 'Beginn',
    csvFin: 'Ende',
    csvDuracion: 'Dauer (min)',
    sesionActiva: 'Aktive Sitzung',
    errorGuardarUsuario: 'Fehler beim Speichern des Benutzers: {msg}',
    noBloquearAdmin: 'Ein Administrator kann nicht gesperrt werden',
    bloquearConfirm: '{nombre} sperren? Bis zur Entsperrung können keine Änderungen gespeichert werden.',
    desbloquearConfirm: '{nombre} entsperren?',
    errorActualizarUsuario: 'Fehler beim Aktualisieren des Benutzers: {msg}',
    datosCuenta: 'Kontodaten',
    nombre: 'Name',
    email: 'E-Mail',
    emailGestionadoAuth: 'Die E-Mail wird von Firebase Auth verwaltet',
    pagadoHasta: 'Bezahlt bis',
    pruebaHasta: 'Testphase bis {fecha}. ',
    sinPrueba: 'Keine Testphase erfasst. ',
    dejaloVacio: 'Leer lassen, um als unbezahlt zu markieren.',
    rolGlobal: 'Globale Rolle',
    rolUsuarioPermisos: 'Benutzer (berechtigungsbasiert)',
    rolAdminTodo: 'Administrator (alles erlaubt)',
    permisosEspecificos: 'Spezifische Berechtigungen',
    guardarCambios: 'Änderungen speichern',
    estadoRealtime: 'Echtzeitstatus',
    usuariosHoy: 'Benutzer heute',
    historicoTrafico: 'Traffic-Verlauf',
    dias7: '7 TAGE',
    dias30: '30 TAGE',
    dias90: '90 TAGE',
    exportarCsv: 'Audit als CSV exportieren',
    tendenciaActividad: 'Aktivitätstrend (30 Tage)',
    rankingEngagement: 'Engagement-Ranking',
    sesiones: 'Sitzungen',
    tiempoTotal: 'Gesamtzeit',
    min: 'Min.',
    usuariosSistema: 'Systembenutzer',
    gestionIdentidades: 'Verwaltung von Identitäten und granularen Berechtigungen.',
    cuentasSeCrean: 'Konten werden angelegt, wenn sich der Benutzer auf der Website registriert. Hier werden Name, Rolle, Berechtigungen und Zahlungen bearbeitet sowie Konten gesperrt oder entsperrt.',
    rolPermisos: 'Rolle / Berechtigungen',
    adminTotal: 'VOLL-ADMIN',
    sinAccesos: 'Kein Zugriff',
    bloqueado: 'GESPERRT',
    editar: 'Bearbeiten',
    desbloquear: 'Entsperren',
    bloquear: 'Sperren',
    auditoriaErrores: 'Audit kritischer Fehler (Firebase)',
    auditoriaErroresDesc: 'Protokoll der von der Plattform gemeldeten Synchronisierungs- oder Datenbankfehler.',
    sinErrores: 'Es wurden keine Systemfehler erfasst.',
    fechaHora: 'Datum und Uhrzeit',
    operacion: 'Vorgang',
    mensajeError: 'Fehlermeldung',
    afectado: 'Betroffen',
    // ─── Passwort und Verifizierung (Einstellungen → Profil) ───
    passTitulo: 'PASSWORT UND SICHERHEIT',
    passActual: 'Aktuelles Passwort',
    passNueva: 'Neues Passwort',
    passRepetir: 'Neues Passwort wiederholen',
    passGuardar: 'Passwort ändern',
    passCrear: 'Passwort erstellen',
    passCrearTexto: 'Ihr Konto meldet sich mit Google an und hat noch kein Passwort: Erstellen Sie eines, um sich auch mit Ihrer E-Mail anzumelden.',
    passOk: 'Passwort aktualisiert.',
    passNoCoincide: 'Die Passwörter stimmen nicht überein.',
    passCorta: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    passActualMal: 'Das aktuelle Passwort ist nicht korrekt.',
    passError: 'Passwort konnte nicht geändert werden: {msg}',
    passVerificado: 'E-Mail bestätigt',
    passSinVerificar: 'E-Mail nicht bestätigt',
  }
};
